import { Col, Row } from "antd";
import Text from "../Text/Text";

interface Props {
  title: string;
  extra?: React.ReactNode;
  extraSpan?: number;
}
const PageTitle = ({ title, extra, extraSpan }: Props) => {
  return (
    <Row justify='space-between'>
      <Col span={extraSpan ? 24 - extraSpan : undefined}>
        <div>
          <Text level={2} color='Text2'>
            {title}
          </Text>
        </div>
      </Col>
      {extra && <Col span={extraSpan}>{extra}</Col>}
    </Row>
  );
};
export default PageTitle;
